// extracted by extract-css-chunks-webpack-plugin
module.exports = {"deliveryMsgTheme":"p8fTl"};